import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useTypedSelector } from '@Features/store';
import { webContentsGetSingle } from '../../Slice/WebContent.slices';
import EditWebContentInfo from './EditWebContentInfo';
import { useUnitPermissions } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/useUnitPermissions';

const EditWebContent = () => {
	const { id } = useParams<{ id: string }>();
	const {
		currentEntity,
		loaders: { getSingle },
	} = useTypedSelector((state) => state.WebContents);
	const { canUpdate } = useUnitPermissions();
	const history = useHistory();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!canUpdate) {
			history.goBack();
			return;
		}
		dispatch(
			webContentsGetSingle({
				id: Number(id),
			})
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	if (!canUpdate) return null;

	return (
		<>{currentEntity && getSingle === 'fulfilled' && <EditWebContentInfo />}</>
	);
};

export default EditWebContent;
